import { Box, Dialog } from '@material-ui/core';
import React, { ReactElement, ReactNode } from 'react';

export interface IDialogWindowProps {
	open: boolean;
	className?: string;
	fullScreen?: boolean | undefined;
	children?: ReactNode;
	disableAutoFocus?: boolean;
	onClose?: () => void;
}

export function DialogWindow(props: IDialogWindowProps): ReactElement {
	const { className, open, fullScreen, children, disableAutoFocus, onClose } =
		props;

	return (
		<Dialog
			id="app"
			classes={{
				paperWidthSm: className ? className : 'dialog-window-container'
			}}
			fullScreen={fullScreen}
			open={open}
			onClose={onClose}
			disableEnforceFocus={disableAutoFocus}
		>
			<Box className="dialog-window-content">{children}</Box>
		</Dialog>
	);
}
